// biome-ignore lint/style/noRestrictedImports: it's ok to pass it to mocks
import { BlogPostStatusEnum } from 'src/editor/layout/sidebar/website-blog-settings/enums'

export interface BlogPostMockItem {
  id: string
  title: string
  date: string
  status: BlogPostStatusEnum
  categoryId?: string
}

export const blogPosts: BlogPostMockItem[] = [
  {
    id: '1',
    title: 'How to Build a Successful Online Course',
    date: '2025-01-15',
    status: BlogPostStatusEnum.Published,
  },
  {
    id: '2',
    title: '10 Tips for Growing Your Email List',
    date: '2025-01-20',
    status: BlogPostStatusEnum.Published,
  },
  {
    id: '3',
    title: 'Understanding Funnel Optimization Strategies',
    date: '2025-02-01',
    status: BlogPostStatusEnum.Scheduled,
  },
  {
    id: '4',
    title: 'The Ultimate Guide to Affiliate Marketing',
    date: '2025-02-10',
    status: BlogPostStatusEnum.Draft,
  },
  {
    id: '5',
    title: 'How to Price Your Digital Products',
    date: '2025-02-14',
    status: BlogPostStatusEnum.Published,
  },
  {
    id: '6',
    title: 'Webinar Best Practices for 2025',
    date: '2025-02-18',
    status: BlogPostStatusEnum.Scheduled,
  },
  {
    id: '7',
    title: 'Creating Compelling Landing Pages',
    date: '2025-02-22',
    status: BlogPostStatusEnum.Draft,
  },
  {
    id: '8',
    title: 'Social Media Strategies That Convert',
    date: '2025-03-01',
    status: BlogPostStatusEnum.Published,
  },
  {
    id: '9',
    title: 'SEO for Content Creators: A Beginner Guide',
    date: '2025-03-05',
    status: BlogPostStatusEnum.Draft,
  },
  {
    id: '10',
    title: 'Automation Tools Every Online Entrepreneur Needs',
    date: '2025-03-10',
    status: BlogPostStatusEnum.Scheduled,
  },
]
